import React from "react";
import { Link } from "react-router-dom";
import { Table, Button } from "react-bootstrap";
import Footer from "../../../footer.js";
import Header from "../../../header/header.js";
import Navvbar from "../../../header/Navvbar.js";

const DDXAdd = () => {
    const data = [
        {
            id: 1,
            title: "EXPORT SCANS/ UPLOAD DDX",
            teaser: "EXPORTING SCANS AND UPLOADING TO DDX",
            start: "14 Aug 2020",
            end: "14 Oct 2020",
        },
        {
            id: 2,
            title: "EXPORT SCANS/ UPLOAD DDX",
            teaser: "EXPORTING SCANS AND UPLOADING TO DDX",
            start: "8 Aug 2020",
            end: "4 Oct 2020",
        },
        {
            id: 3,
            title: "EXPORT SCANS/ UPLOAD DDX",
            teaser: "EXPORTING SCANS AND UPLOADING TO DDX",
            start: "24 Aug 2020",
            end: "20 Oct 2020",
        },
    ];
 

    return (
        <>
            {/* Logo Component */}
            <Header />
            <Navvbar/>
            <br />

            <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
                <div className="row">
                    {/* Sidebar */}
                   <div className="col-md-2" style={{ borderRight: '1px solid #004aad'  }}>
                      <h3>Promotions</h3>
                      <div>
                          <div style={{ marginBottom: "10px" }}>
                              <Link to="/website" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Websites</Link>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                              <Link to="/ddxAdd" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Ads</Link>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                              <Link to="/coupon" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>DDX Coupons</Link>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                              <Link to="/widgets" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>Widgets</Link>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                              <Link to="/action" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '500',marginBottom: '10px',marginLeft:"15px"}}>Links</Link>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                              <Link to="/ddxAccount" style={{ textDecoration: 'none',color: '#004aad',  fontWeight: '300',marginBottom: '10px',marginLeft:"15px",fontSize:"15px"}}>DDX Account Onboarding</Link>
                          </div>
                      </div>
                  </div>
                
                    {/* Main Content Area */}
                    <div className="col-md-10 mt-4">
                        <div className="d-flex justify-content-between align-items-center">
                            <h5 style={{fontWeight: "bold", fontSize: "25px"}}>DDX Ads</h5>
                            <Link to="/addButton">
                                <Button style={{ backgroundColor: "#004aad", color: "white" }}>
                                    Add New
                                </Button>
                            </Link>

                        </div>
                        <br />

                        <Table className="custom-table" hover responsive>
    <thead>
        <tr>
            <th style={{backgroundColor:"#f0f0f0"}}>Title</th>
            <th style={{backgroundColor:"#f0f0f0"}}>Teaser</th>
            <th style={{backgroundColor:"#f0f0f0"}}>Start</th>
            <th style={{backgroundColor:"#f0f0f0"}}>End</th>
            <th style={{backgroundColor:"#f0f0f0"}}>Actions</th>
        </tr>
    </thead>
    <tbody>
        {data.map((item) => (
            <tr key={item.id}>
                <td>{item.title}</td>
                <td>{item.teaser}</td>
                <td>{item.start}</td>
                <td>{item.end}</td>
                <td>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <Link to="/DDXAdd">
                            <Button
                                size="mt-5"
                                style={{
                                    backgroundColor: "#004aad",
                                    color: "white",
                                    marginRight: "20px", // Adds space to the right of the Edit button
                                    width: "80%", // You can adjust the width if needed
                                }}
                            >
                                Edit
                            </Button>
                        </Link>
                        <Button
                            variant="danger"
                            size="mt-3"
                            style={{
                                marginTop: "0px", // To keep them aligned on the same level
                                width: "50%", // Optional: Adjust width as needed
                            }}
                        >
                            Delete
                        </Button>
                    </div>
                </td>
            </tr>
        ))}
    </tbody>
</Table>


                </div>
            </div>
        </div >

            <br />
            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
                <Footer />
            </div>
        </>
    );
};

export default DDXAdd;
